import React from 'react';
import {
    Avatar,
    Box,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Button,
    TextField,
    Grid,
    IconButton,
    Typography,
} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import CloseIcon from '@mui/icons-material/Close';
import { useTheme } from '@mui/material/styles';

const VisitEditModal = ({
    open,
    onClose,
    onSave,
    submitting,
    editForm,
    setEditForm,
    dictionary,
}) => {
    const theme = useTheme();
    return (
        <Dialog open={open} onClose={() => !submitting && onClose()} maxWidth="md" fullWidth>
            <DialogTitle sx={{ p: 0 }}>
                <Box sx={{ px: 2.5, py: 2, bgcolor: '#f3f4f6', borderBottom: '1px solid #e5e7eb' }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 1.5 }}>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.25, minWidth: 0 }}>
                            <Avatar sx={{ width: 38, height: 38, bgcolor: theme.palette.primary.main }}>
                                <EditOutlinedIcon sx={{ fontSize: 22, color: '#fff' }} />
                            </Avatar>
                            <Box sx={{ minWidth: 0 }}>
                                <Typography variant="h6" fontWeight={700} sx={{ lineHeight: 1.1 }}>
                                    {dictionary.visitEditTitle || 'Edit visit'}
                                </Typography>
                                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.35 }}>
                                    {dictionary.visitEditSubtitle || 'Update visit details'}
                                </Typography>
                            </Box>
                        </Box>
                        <IconButton onClick={onClose} size="small" sx={{ color: '#6b7280' }} disabled={submitting}>
                            <CloseIcon />
                        </IconButton>
                    </Box>
                </Box>
            </DialogTitle>
            <DialogContent sx={{ mt: 2}}>
                <Grid container spacing={1.5} py={2}>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label={dictionary.visitEditStart || 'Start datetime'}
                            value={editForm.start_datetime}
                            onChange={(e) => setEditForm((prev) => ({ ...prev, start_datetime: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label={dictionary.visitEditEnd || 'End datetime'}
                            value={editForm.end_datetime}
                            onChange={(e) => setEditForm((prev) => ({ ...prev, end_datetime: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label={dictionary.visitEditActualCheckIn || 'Actual check-in datetime'}
                            value={editForm.actual_check_in_datetime}
                            onChange={(e) => setEditForm((prev) => ({ ...prev, actual_check_in_datetime: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            type="datetime-local"
                            label={dictionary.visitEditActualCheckOut || 'Actual check-out datetime'}
                            value={editForm.actual_check_out_datetime}
                            onChange={(e) => setEditForm((prev) => ({ ...prev, actual_check_out_datetime: e.target.value }))}
                            InputLabelProps={{ shrink: true }}
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditPlatform || 'Platform'}
                            value={editForm.platform}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditIcalUid || 'iCal UID'}
                            value={editForm.ical_uid}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditHouseId || 'House ID'}
                            value={editForm.houses_id}
                            disabled
                        />
                    </Grid>
                    <Grid item xs={12} md={6}>
                        <TextField
                            fullWidth
                            label={dictionary.visitEditInfo || 'Info'}
                            value={editForm.info}
                            onChange={(e) => setEditForm((prev) => ({ ...prev, info: e.target.value }))}
                        />
                    </Grid>
                </Grid>
            </DialogContent>
            <DialogActions sx={{ px: 3, pb: 2 }}>
            <Button onClick={onClose} disabled={submitting}>
                {dictionary.visitActionCancel || 'Cancel'}
            </Button>
            <Button variant="contained" onClick={onSave} disabled={submitting || !editForm.start_datetime || !editForm.end_datetime}>
                {dictionary.visitActionSave || 'Save'}
            </Button>
            </DialogActions>
        </Dialog>
    );
};

export default VisitEditModal;
